// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 100 100%27%3E%3Cdefs%3E%3Cpattern id=%27grid%27 width=%2710%27 height=%2710%27 patternUnits=%27userSpaceOnUse%27%3E%3Cpath d=%27M 10 0 L 0 0 0 10%27 fill=%27none%27 stroke=%27rgba%28255,255,255,0.1%29%27 stroke-width=%270.5%27/%3E%3C/pattern%3E%3C/defs%3E%3Crect width=%27100%27 height=%27100%27 fill=%27url%28%23grid%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8rem 0 4rem;
  text-align: center;
  overflow: hidden;
}

.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.content {
  max-width: 800px;
  margin: 0 auto;
}

.title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
}

.buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.primary-button {
  background:#2563eb;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s ease;
}

/* .primary-button:hover {
  background: #f3f4f6;
} */

.secondary-button {
  border: 2px solid white;
  color: white;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  background: transparent;
}

.secondary-button:hover {
  background: white;
  color: #2563eb;
}

@media (max-width: 768px) {
  .hero {
    padding: 6rem 0 3rem;
  }

  .title {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.125rem;
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
    max-width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuestPage/Hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAA8X;EAC9X,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".hero {\n  position: relative;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8rem 0 4rem;\n  text-align: center;\n  overflow: hidden;\n}\n\n.background-pattern {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cdefs%3E%3Cpattern id='grid' width='10' height='10' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23grid)'/%3E%3C/svg%3E\");\n  opacity: 0.3;\n}\n\n.container {\n  position: relative;\n  z-index: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n}\n\n.subtitle {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  line-height: 1.6;\n}\n\n.buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.primary-button {\n  background:#2563eb;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 0.3s ease;\n}\n\n/* .primary-button:hover {\n  background: #f3f4f6;\n} */\n\n.secondary-button {\n  border: 2px solid white;\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  background: transparent;\n}\n\n.secondary-button:hover {\n  background: white;\n  color: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 6rem 0 3rem;\n  }\n\n  .title {\n    font-size: 2.5rem;\n  }\n\n  .subtitle {\n    font-size: 1.125rem;\n  }\n\n  .buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .primary-button,\n  .secondary-button {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
